import Reflux from 'reflux';

import { Report, ReportScheduling, ReportWidgetPosition, ParameterValues } from 'report/types';

type ReportsActionsType = {
  list: () => Promise<unknown>,
  listPage: (request: { page: number, perPage: number, query: string }) => Promise<unknown>,
  create: (report: Report, reportLogo: string, parameterValues: ParameterValues) => Promise<unknown>,
  get: (reportId: string) => Promise<unknown>,
  getReportLogo: (reportId: string) => Promise<unknown>,
  update: (report: Report, reportLogo: string, parameterValues: ParameterValues) => Promise<unknown>,
  updateScheduling: (reportId: string, scheduling: ReportScheduling) => Promise<unknown>,
  updatePositions: (reportId: string, positions: Array<ReportWidgetPosition>) => Promise<unknown>,
  delete: (report: Report) => Promise<unknown>,
  sendEmail: (report: Report) => Promise<unknown>,
  getHistory: (report: Report, skip: number, limit: number) => Promise<unknown>,
};

const ReportsActions = Reflux.createActions<ReportsActionsType>({
  list: { asyncResult: true },
  listPage: { asyncResult: true },
  create: { asyncResult: true },
  get: { asyncResult: true },
  getReportLogo: { asyncResult: true },
  update: { asyncResult: true },
  updateScheduling: { asyncResult: true },
  updatePositions: { asyncResult: true },
  delete: { asyncResult: true },
  sendEmail: { asyncResult: true },
  getHistory: { asyncResult: true },
});

export default ReportsActions;
